<template>
  <Layout :isLoading="isLoading">
    <div class="bloco">
      <HeaderPage
        :page-titles="pageTitles"
        :form-open="form"
        :newButtonText="'Incluir'"
        @onClick="formOpen"
      />
      <section v-if="form">
        <div>
          <b-input-group prepend="Pesquisar Cliente" class="mt-3 mb-4">
            <b-form-input v-model="filter"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click="handleGet">Pesquisar</b-button>
            </b-input-group-append>
          </b-input-group>
          <div>
            <p>Nome: {{cliente.nome}}</p>
            <p>Numero Do Cartão: {{cliente.cartao}}</p>
            <p>Titular: {{cliente.nome}}</p>
            <p>Saldo: R$ {{cliente.saldo}}</p>
          </div>
        </div>
        <Table :search="false" :comprovante="true" @getComprovante="getComprovante($event)" :table-items="itens" :tables-fields="itensField" @onEdit="modalEdit($event)" @onDelete="onDelete($event)">
        </Table>
      </section>
      <section v-else>
        <FormDepositoClientes :deposito="deposito" :onEdit="handleEdit" :onSubmit="handleCreate"></FormDepositoClientes>
      </section>
      <b-modal id="deposito-comprovante" hide-footer centered size="lg">
        <Comprovante :comprovante=depositoComprovante></Comprovante>
      </b-modal>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import Table from '../../../../components/tables/table-register.vue'
import DepositoClientes from '../../../../components/forms/financeiro/deposito-cliente-form.vue'
import Comprovante from './comprovante.vue'
import Pagamentos from '@/src/services/pagamento'
import alertMixin from '@/src/mixins/alertMixin'
import { mapState } from "vuex";

export default {
  components: {
    Layout,
    HeaderPage,
    Table,
    FormDepositoClientes: DepositoClientes,
    Comprovante
  },
  mixins: [alertMixin],
  data() {
    return {
      pageTitles: {
        title: 'Depósitos De Clientes',
        subtitle: 'Depósitos Dos Clientes',
      },
      form: true,
      itens: [],
      itensField: [
        { key: 'operacao', label: 'Operação' },
        { key: 'valor', label: 'Valor' },
        { key: 'data', label: ' Data' },
        { key: 'forma_pagamento', label: 'Pagamento' },
        { key: 'protocolo', label: 'Nº de Protoclo' },
        { key: 'identificacao', label: 'Nº de Identificação' },
        { key: 'actions', label: '' },
      ],
      cliente: {},
      deposito: {},
      filter: '',
      isLoading: false,
      caixa: '',
      depositoComprovante: {},
      userType: this.$store.state.auth.currentUser.type,
    }
  },
  computed: {
    ...mapState('auth', [
      'currentUser',
    ]),
  },
  mounted(){
    this.caixa = this.$route.query.caixa
    if(this.caixa)
      this.handleGet()
    else
      this.$router.push({
        path: '/financeiro/gerenciamento-caixa',
      })
  },
  methods: {
    getComprovante(comprovante){
      this.depositoComprovante = comprovante
      this.$bvModal.show('deposito-comprovante')
    },
    handleGet(){
        this.isLoading = true
        Pagamentos.list('deposito', this.filter, null, null,null, this.caixa).then(response=>{
          this.itens = response.data.pagamentos
          this.cliente = response.data.responsavel?response.data.responsavel:{}
        }).catch(error=>{
          this.errorMessage(error)
        }).finally(()=>{
          this.isLoading = false
        })
     
    },
    handleCreate(){
      const user = this.currentUser.usuario

      this.deposito.atendente = user._id
      this.deposito.caixa = this.caixa
      if(!this.deposito["tipo"])
        this.deposito["tipo"] = "deposito"

      this.isLoading = true

      Pagamentos.create(this.deposito).then(()=>{
        this.deposito = {}
        this.successMessage('Depósito Criado com sucesso')
        this.handleGet()
      }).catch(error=>{
        this.errorMessage(error.response.data?error.response.data.message:'Erro inesperado.')
      }).finally(()=>{
        this.isLoading = false
      })
    },
    handleEdit(){
      this.isLoading = true
      Pagamentos.update(this.deposito._id, this.deposito).then(()=>{
        this.deposito = {}
        this.successMessage('Depósito Editado com sucesso')
        this.formOpen()
      }).catch(error=>{
        this.errorMessage(error.response.data?error.response.data.message:'Erro inesperado.')
      }).finally(()=>{
          this.isLoading = false
        })
    },
    modalEdit(item){
      this.deposito = item
      this.formOpen()
    },
    onDelete(id) {
      try {
        this.clientes = []
        Pagamentos.remove(id).then(()=>{
          this.handleGet()
          this.successMessage('Depósito Deletado com sucesso')
        })
      } catch (error) {
        this.errorMessage(error)
      }
    },
    formOpen() {
      if (this.form === false) {
        this.deposito = {}
        this.form = true
      } else {
        this.handleGet()
        this.form = false
      }
    },
  },
}
</script>
<style src="../style.scss" lang="scss" scoped></style>
